import React, { PureComponent } from 'react';

class LoadingSpinner extends PureComponent {
    render() {
        const {
            sm
        } = this.props;

        return (
            <div className={"text-center text-primary " + (sm ? "d-inline-block mb-1" : "py-4")}>
                <i className={"fa fa-spinner-third fa-spin " + (sm ? "fa-2x" : "fa-4x")}></i>
            </div>
        );
    }
}

LoadingSpinner.defaultProps = {
    sm: false
};

export default LoadingSpinner;
